import { render, staticRenderFns } from "./CollectFilterMyPageLayout.vue?vue&type=template&id=4c6c3e13&scoped=true"
import script from "./CollectFilterMyPageLayout.vue?vue&type=script&lang=js"
export * from "./CollectFilterMyPageLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6c3e13",
  null
  
)

export default component.exports